import axios from 'axios'
import api from './index.js'
// axios默认配置
axios.defaults.timeout = 100000;   // 超时时间
axios.defaults.baseURL = api.ajaxUrl;  // 默认地址

//整理数据
//axios.defaults.transformRequest = function (data) {
////data = Qs.stringify(data);
//data = JSON.stringify(data);
//return data;
//};
let ajaxCur = 0;
// 路由请求拦截
// http request 拦截器
axios.interceptors.request.use(
  config => {
  	ajaxCur ++;
  	if(ajaxCur==1){
  		api.startLoading();
  	}
    //config.data = JSON.stringify(config.data);      
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';   
    if (localStorage.getItem("token")) {        　　　 
　　　　 //config.headers.name= cookie.get("name");
				config.headers.token = localStorage.getItem("token");
    }    
    return config;
  },
  error => {
    return Promise.reject(error.response);
  }
);

// 路由响应拦截
// http response 拦截器
axios.interceptors.response.use(
  response => {  	
  	ajaxCur--;
  	if(ajaxCur<=0){
  		api.endLoading();
  	}
    if (response.data.resultCode=="100") {//tonken 错误
        api.loginout()
        return
    }else{
        return response;
    }
  },
  error => {
  	ajaxCur--;
  	if(ajaxCur<=0){
  		api.endLoading();
  	}
  	alert("接口错误!")
    return Promise.reject(error.response)   // 返回接口返回的错误信息
  });
export default axios;


// WEBPACK FOOTER //
// ./src/public/axiosdefault.js